import { Container } from '../ui/Container'
import { Reveal } from '../ui/Reveal'

const stats = [
  { value: '4+', label: 'Years operating' },
  { value: '16+', label: 'Projects completed' },
  { value: '2022', label: 'Building since' },
]

export function Proof() {
  return (
    <section className="border-b border-ink/10 py-20">
      <Container>
        <Reveal>
          <div className="grid grid-cols-1 gap-10 border-t border-ink/10 pt-10 sm:grid-cols-3">
            {stats.map((stat) => (
              <div key={stat.label}>
                <div className="font-display text-3xl font-semibold tracking-tight">{stat.value}</div>
                <div className="mt-2 text-sm text-graphite">{stat.label}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </Container>
    </section>
  )
}
